export default __webpack_public_path__ + "static/media/Snare2.57007b06.mp3";